import { isHelixOnlyHub } from 'utils/helix';

// Checks if the AI Coach should be shown in the navbar, including in the search bar
export function showAiCoachInNavbar(hasMindsetAgent) {
  return hasMindsetAgent && !isHelixOnlyHub;
}